import { Mui } from '@osu/react-ui';
import styles from '../../dd-styles';
import Chip from './scoresChip';

const OtherScores = (props) => {
  const { studentData } = props;
  const committeeId = studentData?.data?.demographics?.committeeId;
  const isCCP = ["ccp-metro-hs", "ccp-academy", "ccp-academy-regional"].includes(committeeId);

  if (!isCCP) {
    return null; 
  }

  const accuplacer = studentData?.data?.scores?.accuplacer;
  if (!accuplacer || accuplacer.length === 0) {
    return null;
  }

  return (
    <div>
      <Mui.Typography tabIndex="0" aria-label='ACCUPLACER' component="h3" variant="h6">
        ACCUPLACER
      </Mui.Typography>
      {accuplacer.map?.((item, index) => (
        <dl title="ACCUPLACER" key={index} style={styles.dl}>
          <dd tabIndex="0" style={styles.dd}>
            <Chip
              label={'Date'}
              childLabel={item.map((item) =>
                new Date(item.date).toLocaleDateString() ?? "N/A"
              )}
            />
          </dd>
          <dd tabIndex="0" style={styles.dd}>
            <Chip
              label={'Next Gen Quantitative Reasoning'}
              childLabel={item.map((item) => item.reasoning ?? "N/A")}
            />
          </dd>
          <dd tabIndex="0" style={styles.dd}>
            <Chip
              label={'Next Gen Reading'}
              childLabel={item.map((item) => item.readingNextGen ?? "N/A")}
            />
          </dd>
          <dd tabIndex="0" style={styles.dd}>
            <Chip
              label={'Next Gen Writing'}
              childLabel={item.map((item) => item.writingNextGen ?? "N/A")}
            />
          </dd>
          <Mui.Divider />
        </dl>
      ))}
    </div>
  );
};

export default OtherScores;
